import { KBSourcesPage } from '@/UI/Insights/KBSources/KBSources.page';

export const KBSourcesLoader = () => <KBSourcesPage />;
